const responseCustomerFormat = [
    {
        back: 'customer_sale_with_cash_total',
        front: 'customerSaleWithCashTotal',
    },
    {
        back: 'customer_sale_with_credit_cash_total',
        front: 'customerSaleWithCreditCashTotal',
    },
    {
        back: 'customer_sale_with_debit_card_total',
        front: 'customerSaleWithDebitCardTotal',
    },
    {
        back: 'customer_sale_with_check_total',
        front: 'customerSaleWithCheckTotal',
    },
    {
        back: 'customer_sale_with_customer_credit_total',
        front: 'customerSaleWithCustomerCreditTotal',
    },
]

const responseEmployeeFormat=[
    {
        back: 'employee_sale_with_cash_total',
        front: 'employeeSaleWithCashTotal',
    },
    {
        back: 'employee_sale_with_credit_cash_total',
        front: 'employeeSaleWithCreditCashTotal',
    },
    {
        back: 'employee_sale_with_debit_card_total',
        front: 'employeeSaleWithDebitCardTotal',
    },
    {
        back: 'employee_sale_with_check_total',
        front: 'employeeSaleWithCheckTotal',
    },
    {
        back: 'employee_sale_with_employee_credit_total',
        front: 'employeeSaleWithEmployeeCreditTotal',
    },
]

const responseEgressTotal=[
    {
        back: 'egress_cash_movement_total',
        front: 'egressCashMovementTotal'
    }
]

const customerTotalResponse = [
    {
        back: 'customer_sales_total',
        front: 'customerSalesTotal',
    }
]

const employeeTotalResponse =[
    {
        back : 'employee_sales_total',
        front: 'employeeSalesTotal',
    }
]
export {
    responseCustomerFormat,
    responseEmployeeFormat,
    responseEgressTotal,
    customerTotalResponse,
    employeeTotalResponse,
}
//TODO: change ALL name for ex customerFormatResponse 